$(document).ready(function() {
    setTimeout(function() {
        if(!getCookie('newsletter_done')) {  
        $('.custom-newsletter').addClass('visible');
        $('body').css('overflow', 'hidden')
        }
    }, 10000); // 10,000 milliseconds = 10 seconds
    $('.close-icon, .custom-newsletter-left span').click(function(){
        $('.custom-newsletter').removeClass('visible');
        $('body').css('overflow', 'visible')
      setCookie('newsletter_done',true,7);
    })
});
